import React from "react";

export function isDexAggregatorExecutionCostClass(value) {
  const cls = String(value || "").trim().toLowerCase();
  return (
    cls === "dex_aggregator_execution_cost" ||
    cls === "dex_aggregator_fee"
  );
}

export function getDexAggregatorExecutionCostPlainLabel(tx = {}) {
  const application = String(
    tx.application || tx.protocolLabel || tx.dexLabel || tx.protocol || "DEX Aggregator"
  ).trim();
  return `${application} · Execution Cost`;
}

export default function DexAggregatorExecutionCostLabel({ tx = {} }) {
  const application = String(
    tx.application || tx.protocolLabel || tx.dexLabel || tx.protocol || "DEX Aggregator"
  ).trim();
  const icon =
    tx.protocolIcon ||
    tx.dexIcon ||
    (application === "BetterSwap" ? "/Betterswap.png" : "");
  const venueRoute = String(
    tx.routeVenueLabel ||
      (Array.isArray(tx.routeVenueLabels) ? tx.routeVenueLabels.join(" → ") : "")
  ).trim();
  const executionRoute = String(tx.executionRouteLabel || "").trim();
  const tooltip = [
    venueRoute ? `via ${venueRoute}` : "",
    executionRoute ? `Route: ${executionRoute}` : "",
  ].filter(Boolean).join("\n");

  return (
    <span
      className="inline-flex items-start gap-2 text-orange-600 font-semibold min-w-0"
      title={tooltip || undefined}
    >
      {icon ? (
        <img
          src={icon}
          alt={application}
          className="h-5 w-5 object-contain flex-shrink-0 mt-0.5"
          draggable={false}
        />
      ) : null}
      <span className="min-w-0 leading-tight text-left">
        <span className="block whitespace-normal break-words">{application}</span>
        <span className="block whitespace-normal break-words text-[11px] font-medium text-orange-700/90">
          Execution Cost
        </span>
      </span>
    </span>
  );
}
